import { splitMoney } from "../lib/format";

interface Props {
  balance: string;
  currency: string;
  size?: "hero" | "md" | "sm";
  zeroLabel?: string;
}

const sizeClass = {
  hero: "font-sans text-5xl font-semibold leading-none tracking-tight [font-variant-numeric:tabular-nums]",
  md:   "font-mono text-base font-semibold [font-variant-numeric:tabular-nums]",
  sm:   "font-mono text-sm font-medium [font-variant-numeric:tabular-nums]",
};

export function BalanceAmount({ balance, currency, size = "md", zeroLabel = "All settled" }: Props) {
  const n = parseFloat(balance);
  const base = sizeClass[size];

  if (isNaN(n) || n === 0) {
    return <span className={`${base} text-muted`}>{zeroLabel}</span>;
  }

  const { symbol, int, frac } = splitMoney(balance, currency);
  const color = n > 0 ? "text-success" : "text-danger";
  const sign = n > 0 ? "+" : "−";

  if (size === "hero") {
    // De-emphasize the cents (smaller + lighter) — a common banking pattern.
    return (
      <span className={`${base} ${color}`}>
        {sign}{symbol}{int}<span className="text-[0.5em] font-medium align-baseline">{frac}</span>
      </span>
    );
  }

  return <span className={`${base} ${color}`}>{sign}{symbol}{int}{frac}</span>;
}
